import { render } from "./DenialModal.vue?vue&type=template&id=68e7f080"
import script from "./DenialModal.vue?vue&type=script&lang=js"
export * from "./DenialModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bytedance/New/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__